import React from 'react';
import MessageBoard from "./pages/MessageBoard";


function App() {
  return (
    <>
      <MessageBoard />
    </>
  );
}

export default App;
